/** @format */

/**
 * Helpers for deciding where to send unauthenticated or "lost" users.
 *
 * FundsyFi has two separate product surfaces:
 *  - FundsyFi Circle  (savings circles / ROSCA)
 *  - FundsyFi Recover (customer accountability & invoice recovery)
 *
 * The default sign-in lives at "/circle/sign-in". Sending a Collect user there
 * is misleading, so for anyone currently inside the Collect product we keep the
 * redirect within Collect instead.
 */

/** Public, Collect-branded landing page (FundsyFi Recover home). */
export const COLLECT_HOME_PATH = "/business";

/** Authenticated Collect workspace home (dashboard). */
export const COLLECT_WORKSPACE_PATH = "/collect";

/** Default sign-in destination for unauthenticated users. */
export const CIRCLE_SIGN_IN_PATH = "/circle/sign-in";

/** True when the given path belongs to the FundsyFi Recover product surface. */
export const isCollectPath = (pathname: string): boolean =>
    pathname === COLLECT_HOME_PATH ||
    pathname.startsWith(`${COLLECT_HOME_PATH}/`) ||
    pathname === COLLECT_WORKSPACE_PATH ||
    pathname.startsWith(`${COLLECT_WORKSPACE_PATH}/`);

/**
 * Returns where an unauthenticated user should be redirected.
 * Collect users are kept inside the Collect product (so they never land on the
 * Circle sign-in page); everyone else goes to the Circle sign-in.
 */
export const getUnauthRedirectPath = (
    pathname: string = window.location.pathname,
): string => (isCollectPath(pathname) ? COLLECT_HOME_PATH : CIRCLE_SIGN_IN_PATH);
